import { NotificationType } from '@shared/types/db/notifications';
import Loading from '@/components/shared/Loading';
import Seo from '@/components/shared/Seo';
import { Switch } from '@/components/ui/switch';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import useGetNotificationSettings from '@/hooks/settings/useGetNotificationSettings';
export default function NotificationsSettingsPage() {
  const {
    notificationSettings,
    isLoading,
    updateNotificationSettings
  } = useGetNotificationSettings();
  async function handleUpdateNotificationSettings(key: string) {
    const value = !notificationSettings?.[key];
    await updateNotificationSettings({
      ...notificationSettings,
      [key]: value
    });
  }
  return <div className='flex flex-col lg:flex-row overflow-x-hidden overflow-y-scroll' data-sentry-component="NotificationsSettingsPage" data-sentry-source-file="index.tsx">
      <Seo nofollow noindex title='Notifications • Genius • Trade Crypto Like a Genius' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <div className='bg-genius-indigo h-screen grow'>
        <div className='w-full flex justify-between items-center mt-4 pl-4'>
          <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="index.tsx" />
        </div>
        <div className='pt-5'>
          {isLoading ? <div className='h-[70vh] flex items-center justify-center'>
              <Loading />
            </div> : <>
              {' '}
              <div className='flex pl-4 items-center pb-4'>
                <div className='flex flex-col w-2/3 title text-genius-cream text-[20px] font-light'>
                  Notifications
                </div>
              </div>
              <div className='flex flex-col items-start gap-0 '>
                <div className=' border-t w-full pt-4 mt-4 pl-4'>Personal</div>
                <div className='flex flex-col gap-y-4 mt-4 items-start pl-8 w-full'>
                  <div className='flex items-center justify-between pr-8 w-full '>
                    Portfolio Updates{' '}
                    <Switch checked={notificationSettings?.[NotificationType.PORTFOLIO_UPDATES]} onClick={() => handleUpdateNotificationSettings(NotificationType.PORTFOLIO_UPDATES)} className='ml-4' />
                  </div>
                </div>
                <div className=' border-t w-full pt-4 mt-4 pl-4'>Social</div>
                <div className='flex flex-col gap-y-4 mt-4 items-start pl-8 w-full'>
                  <div className='flex items-center   justify-between pr-8  w-full'>
                    Friend Requests{' '}
                    <Switch onClick={() => handleUpdateNotificationSettings(NotificationType.FRIEND_REQUESTS)} checked={notificationSettings?.[NotificationType.FRIEND_REQUESTS]} className='ml-4' />
                  </div>
                  <div className='flex items-center justify-between pr-8 w-full '>
                    Friend Trades{' '}
                    <Switch onClick={() => handleUpdateNotificationSettings(NotificationType.FRIEND_TRADES)} checked={notificationSettings?.friend_trades} className='ml-4' />
                  </div>
                  {/* <div className='flex items-center justify-between pr-8 w-full '>
                    Whale Trades{' '}
                    <Switch
                      onClick={() =>
                        handleUpdateNotificationSettings(NotificationType.WHALE_TRADES)
                      }
                      checked={notificationSettings?.[NotificationType.WHALE_TRADES]}
                      className='ml-4'
                    />
                   </div> */}
                  <div className='flex items-center justify-between pr-8 w-full '>
                    Genius Transfers
                    <Switch onClick={() => handleUpdateNotificationSettings(NotificationType.USER_TRANSFER)} checked={notificationSettings?.[NotificationType.USER_TRANSFER]} className='ml-4' />
                  </div>
                </div>
                {/* <div className=' border-t w-full pt-4 mt-4 pl-4'>Price Alerts</div>
                 <div className='flex flex-col gap-y-4 mt-4 items-start pl-8 w-full'>
                  <div className='flex items-center justify-between pr-8 w-full'>
                    Saved Tokens{' '}
                    <Switch
                      onClick={() =>
                        handleUpdateNotificationSettings(NotificationType.SAVED_TOKENS)
                      }
                      checked={notificationSettings?.[NotificationType.SAVED_TOKENS]}
                      className='ml-4'
                    />
                  </div>
                  <div className='flex items-center justify-between pr-8 w-full'>
                    Recents Tokens{' '}
                    <Switch
                      onClick={() =>
                        handleUpdateNotificationSettings(NotificationType.RECENTS_TOKENS)
                      }
                      checked={notificationSettings?.[NotificationType.RECENTS_TOKENS]}
                      className='ml-4'
                    />
                  </div>
                 </div> */}
              </div>
            </>}
        </div>
      </div>
    </div>;
}